import styled from 'styled-components'

import { StatusCardLegacyContentLeftStyled } from './StatusCardLegacyContentLeftStyled'
import { StatusCardLegacyContentRightStyled } from './StatusCardLegacyContentRightStyled'
import { StatusCardLegacyContentTable } from '../components/StatusCardLegacyContentTable'

const StatusCardLegacyContentStyled = styled.div`
  font-size: ${(p) => p.theme.typography.pxToRem(16)};

  display: flex;
  grid-area: content;
  padding: 0 0.5em;

  ${StatusCardLegacyContentLeftStyled} + ${StatusCardLegacyContentRightStyled} {
    padding-left: 1em;
  }
`

export const StatusCardLegacyContent = ({ ...props }) => (
  <StatusCardLegacyContentStyled {...props} />
)

StatusCardLegacyContent.Left = StatusCardLegacyContentLeftStyled
StatusCardLegacyContent.Right = StatusCardLegacyContentRightStyled
StatusCardLegacyContent.Table = StatusCardLegacyContentTable
